import { Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Plan from './Plan';
import { SubscriptionPlanTypes } from '../../types/coach';
import { TypographyVariant } from '../Common/StyledSpan';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { fetchCoachRequest } from '../../redux/coach/coachSlice';
import { CLIENTS_ROUTE } from '../../utils/routes';
import { getPlans } from '../../utils/paymentUtills';

type ISubscriptionPlanCardProps = {
  variant: TypographyVariant;
  xs: number;
  handleSelectPlan: (_planType: SubscriptionPlanTypes) => void;
  onMoreInfoSelect: (_planType: SubscriptionPlanTypes) => void;
};

function SubscriptionPlanCard({
  variant,
  xs,
  handleSelectPlan,
  onMoreInfoSelect,
}: ISubscriptionPlanCardProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const coachId = useAppSelector((state) => state.coach.coach.id);
  const navigate = useNavigate();
  const { isFreeTrialActivated, activateFreePlanLoading } = useAppSelector(
    (state) => state.subscription
  );

  useEffect(() => {
    if (isFreeTrialActivated && coachId) {
      dispatch(fetchCoachRequest());
      navigate(CLIENTS_ROUTE);
    }
  }, [isFreeTrialActivated, coachId]);

  const plans = Object.values(getPlans()).map((plan) => ({
    planIcon: `/assets/icons/${plan.title.toLowerCase()}.svg`,
    planType: plan.planType,
    price: plan.price,
    features: plan.features,
  }));

  return (
    <>
      <Grid item textAlign="center">
        <Typography variant={variant} color="primary.main">
          {t('therapistOnboarding.selectSubscriptionPlan.title')}
        </Typography>
      </Grid>
      <Grid
        container
        pt={5}
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
        spacing={1.5}
        gap={1.5}
      >
        {plans.map((plan) => (
          <Plan
            key={plan.planType}
            planIcon={plan.planIcon}
            planType={plan.planType}
            price={plan.price}
            features={plan.features}
            handleSelectPlan={handleSelectPlan}
            showMoreInfo={onMoreInfoSelect}
            xs={xs}
            sm={5}
            md={4.5}
            lg={2.7}
            loading={plan.planType === SubscriptionPlanTypes.FREE && activateFreePlanLoading}
          />
        ))}
      </Grid>
      <Grid width="100%" pt="20px" display="flex">
        <Typography
          variant="bodyRegular"
          fontWeight={500}
          color="primary"
          textAlign="center"
          width="100%"
        >
          {t('therapistOnboarding.selectSubscriptionPlan.changeLater')}
        </Typography>
      </Grid>
    </>
  );
}

export default SubscriptionPlanCard;
